import { Text } from '@capsicum/common-web';
import { type NCWalletBalanceProps, useNCWalletTotalBalance } from '@capsicum/features/nc-wallet/shared';

/**
 * This is the main component for TotalBalance component
 */
export const TotalBalanceComponent = ({ balance, testID }: NCWalletBalanceProps) => {
	const { balanceOrAsterisk } = useNCWalletTotalBalance(balance);

	return (
		<Text color="main.enabled" testID={testID} variant="title1">
			{balanceOrAsterisk}
		</Text>
	);
};
